import { QuestionTypes, QuestionTypesColor } from "./types";

export function getBorderColorByCardType(cardType) {
    switch (cardType) {
        case QuestionTypes.CREATIVIDAD:
            return QuestionTypesColor.CREATIVIDAD;
        case QuestionTypes.TALENTO:
            return QuestionTypesColor.TALENTO;
        case QuestionTypes.CONOCIMIENTO:
            return QuestionTypesColor.CONOCIMIENTO;
    }
    return '';
}